import axios from './axiosInstances/axiosInstance';

export const createUserFave = (basketid, description) => {
  return axios.post(`/users/favoriteOrders`, { basketid, description });
};
